import Vue from 'vue'
import Router from 'vue-router'

import login from '@/pages/login'
import index from '@/pages/index'

//welcome
import welcome_index from '@/pages/welcome/index'

//system
import system_func from '@/pages/system/func'
import system_func_save from '@/pages/system/func_save'
import system_mod from '@/pages/system/mod'
import system_mod_save from '@/pages/system/mod_save'
import system_mod_role from '@/pages/system/mod_role'
import system_mod_role_func from '@/pages/system/mod_role_func'
import system_cache from '@/pages/system/cache'
import system_ops from '@/pages/system/ops'
import system_setup from '@/pages/system/setup/setup'
import mailSetup from '@/pages/system/mailSetup/mailSetup'

//org
import org_info from '@/pages/org/info/info'
import org_info_save from '@/pages/org/info/info_save'
import org_info_setup from '@/pages/org/info/info_setup'
import org_dep from '@/pages/org/dep/dep'
import org_dep_save from '@/pages/org/dep/dep_save'
import org_dep_user from '@/pages/org/dep/dep_user'
import org_role from '@/pages/org/role/role'
import org_role_save from '@/pages/org/role/role_save'
import org_role_user from '@/pages/org/role/role_user'
import org_role_func from '@/pages/org/role/role_func'
import org_user from '@/pages/org/user/user'
import org_user_add from '@/pages/org/user/user_add'
import org_user_upd from '@/pages/org/user/user_upd'
import org_user_reset_pwd from '@/pages/org/user/user_reset_pwd'
import org_user_setdownrole from '@/pages/org/user/user_setdownrole'
import org_user_listdownrole from '@/pages/org/user/user_listdownrole'
import org_user_ewm from '@/pages/org/ewm/user'
import org_downs0 from '@/pages/org/down/downs0'
import org_downs0_add from '@/pages/org/down/downs0_add'
import org_downs0_upd from '@/pages/org/down/downs0_upd'
import org_downs0_setup from '@/pages/org/down/downs0_setup'
import org_downs0_msg from '@/pages/org/down/downs0_msg'
import org_downs0_higset from '@/pages/org/down/downs0_higset'
import org_downs0_admin from '@/pages/org/down/downs0_admin'
import org_downs0_org_admin from '@/pages/org/down/downs0_org_admin'
import org_downs1 from '@/pages/org/down/downs1'
import org_downs1_upd from '@/pages/org/down/downs1_upd'
import org_downs1_setup from '@/pages/org/down/downs1_setup'
import org_downs1_msg from '@/pages/org/down/downs1_msg'
import org_downs2 from '@/pages/org/down/downs2'
import org_downs2_upd from '@/pages/org/down/downs2_upd'
import org_downs2_setup from '@/pages/org/down/downs2_setup'
import org_downs2_msg from '@/pages/org/down/downs2_msg'
import org_downroles1 from '@/pages/org/downrole/lists1'
import org_downroles1_add from '@/pages/org/downrole/downroles1_add'
import org_downroles1_func from '@/pages/org/downrole/downroles1_func'
import org_downroles1_delete from '@/pages/org/downrole/downroles1_delete'
import org_downroles2 from '@/pages/org/downrole/lists2'
import org_downroles2_add from '@/pages/org/downrole/downroles2_add'
import org_downroles2_func from '@/pages/org/downrole/downroles2_func'
import org_downroles2_delete from '@/pages/org/downrole/downroles2_delete'
import org_ewm_wxmp from '@/pages/org/ewm/wxmp'

// teacher
import teacher_record from '@/pages/teacher/record/record'
import teacher_record_detail from '@/pages/teacher/record/detail'
import teacher_record_trans from '@/pages/teacher/profile/trans_reocrd'
import teacher_profile from '@/pages/teacher/profile/profile'
import teacher_profile_detail from '@/pages/teacher/profile/profile_detail'
import teacher_expire from '@/pages/teacher/expire/expire'

// faculty
import faculty_record from '@/pages/faculty/record/record'
import faculty_record_detail from '@/pages/faculty/record/detail'
import faculty_record_trans from '@/pages/faculty/profile/trans_reocrd'
import faculty_profile from '@/pages/faculty/profile/profile'
import faculty_profile_detail from '@/pages/faculty/profile/profile_detail'
import faculty_expire from '@/pages/faculty/expire/expire'

//email
import email_record from '@/pages/email/record/record'
import email_record_detail from '@/pages/email/record/record_detail'
import email_template from '@/pages/email/template/template'

//cent
import cent_list from '@/pages/cent/list/list'

// school
import school_record from '@/pages/school/record/record'
import school_profile from '@/pages/school/profile/profile'
import school_profile_detail from '@/pages/school/profile/profile_detail'
import school_record_detail from '@/pages/school/record/detail'
import school_record_recruit_detail from '@/pages/school/record/recruit_detail'
import school_job from '@/pages/school/job/job'
import school_expire from '@/pages/school/expire/expire'
import school_white from '@/pages/school/white/white'

//edu
import edu_info from '@/pages/edu/info/info'
import edu_info_item from '@/pages/edu/infoItem/infoItem'
import edu_item_info from '@/pages/edu/infoItem/ItemInfo'
import edu_role from '@/pages/edu/role/role'
import edu_ad from '@/pages/edu/ad/ad'
import edu_blogAd from '@/pages/edu/blogAd/blogAd'
import edu_adInfo from '@/pages/edu/ad/adInfo'
import base_mtag from '@/pages/edu/baseMtag/baseMtag'
import baseMtag_item from '@/pages/edu/baseMtag/baseMtag_item'
import baseMtagItem from '@/pages/edu/baseMtagItem/baseMtagItem'
import renewal from '@/pages/edu/renewal/renewal'
import blog from '@/pages/edu/blog/blog'
import edu_wellnessAd from '@/pages/edu/wellnessAd/wellnessAd'
import edu_travelAd from '@/pages/edu/travelAd/travelAd'
import wellness from '@/pages/edu/wellness/wellness'
import travel from '@/pages/edu/travel/travel'
import think from '@/pages/edu/think/think'
import wealth from '@/pages/edu/wealth/wealth'
import tech from '@/pages/edu/tech/tech'
import techAd from '@/pages/edu/techAd/techAd'

//others
import alumni from '@/pages/others/alumni/alumni'
import parent from '@/pages/others/parent/parent'
import student from '@/pages/others/student/student'

Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/index',
            name: 'index',
            component: index,
            children: [
                {
                    path: 'welcome',
                    name: 'welcome',
                    component: welcome_index,
                }
            ]
        },
        // system
        {
            path: '/system',
            name: 'system',
            component: index,
            children: [
                {
                    path: 'func',
                    name: 'func',
                    component: system_func,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: system_func_save,
                        }
                    ]
                },
                {
                    path: 'mod',
                    name: 'mod',
                    component: system_mod,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: system_mod_save,
                        },
                        {
                            path: 'selectRole',
                            name: 'selectRole',
                            component: system_mod_role,
                        },
                        {
                            path: 'roleFunc',
                            name: 'roleFunc',
                            component: system_mod_role_func,
                        },
                    ]
                },
                {
                    path: 'ops',
                    name: 'ops',
                    component: system_ops,
                    children: []
                },
                {
                    path: 'redis',
                    name: 'redis',
                    component: system_cache,
                },
                {
                    path: 'setup',
                    name: 'setup',
                    component: system_setup,
                },
                {
                    path: 'mail_setup',
                    name: 'mail_setup',
                    component: mailSetup,
                }
            ]
        },
        // edu
        {
            path: '/edu',
            name: 'edu',
            component: index,
            children: [
                {
                    path: 'info',
                    name: 'info',
                    component: edu_info,
                },
                {
                    path: 'info-bottom',
                    name: 'info-bottom',
                    component: edu_info_item,
                },
                {
                    path: 'item-info',
                    name: 'item-info',
                    component: edu_item_info,
                },
                {
                    path: 'role',
                    name: 'role',
                    component: edu_role,
                },
                {
                    path: 'ad',
                    name: 'ad',
                    component: edu_ad,
                },
                {
                    path: 'ad-item',
                    name: 'ad-item',
                    component: edu_adInfo,
                },
                {
                    path: 'ad-blog',
                    name: 'ad-blog',
                    component: edu_blogAd,
                },
                {
                    path: 'ad-wellness',
                    name: 'ad-wellness',
                    component: edu_wellnessAd,
                },
                {
                    path: 'ad-travel',
                    name: 'ad-travel',
                    component: edu_travelAd,
                },
                {
                    path: 'base-mtag',
                    name: 'base-mtag',
                    component: base_mtag,
                },
                {
                    path: 'baseMtag_item',
                    name: 'baseMtag_item',
                    component: baseMtag_item,
                },
                {
                    path: 'base-mtag-item',
                    name: 'base-mtag-item',
                    component: baseMtagItem,
                },
                {
                    path: 'renewal',
                    name: 'renewal',
                    component: renewal,
                },
                {
                    path: 'blog',
                    name: 'blog',
                    component: blog,
                },
                {
                    path: 'wellness',
                    name: 'wellness',
                    component: wellness,
                },
                {
                    path: 'travel',
                    name: 'travel',
                    component: travel,
                },
                {
                    path: 'think',
                    name: 'think',
                    component: think,
                },
                {
                    path: 'wealth',
                    name: 'wealth',
                    component: wealth,
                },
                {
                    path: 'tech',
                    name: 'tech',
                    component: tech,
                },
                {
                    path: 'tech-Ad',
                    name: 'tech-Ad',
                    component: techAd,
                },
            ],
        },
        // org
        {
            path: '/org',
            name: 'org',
            component: index,
            children: [
                {
                    path: 'info',
                    name: 'info',
                    component: org_info,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: org_info_save,
                        },
                        {
                            path: 'setup',
                            name: 'setup',
                            component: org_info_setup,
                        }
                    ]
                },
                {
                    path: 'dep',
                    name: 'dep',
                    component: org_dep,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: org_dep_save,
                        },
                        {
                            path: 'user',
                            name: 'user',
                            component: org_dep_user,
                        }
                    ]
                },
                {
                    path: 'role',
                    name: 'role',
                    component: org_role,
                    children: [
                        {
                            path: 'save',
                            name: 'save',
                            component: org_role_save,
                        },
                        {
                            path: 'user',
                            name: 'user',
                            component: org_role_user,
                        },
                        {
                            path: 'func',
                            name: 'func',
                            component: org_role_func,
                        }
                    ]
                },
                {
                    path: 'user',
                    name: 'user',
                    component: org_user,
                    children: [
                        {
                            path: 'add',
                            name: 'org_user_add',
                            component: org_user_add,
                        },
                        {
                            path: 'upd',
                            name: 'upd',
                            component: org_user_upd,
                        },

                        {
                            path: 'resetPwd',
                            name: 'resetPwd',
                            component: org_user_reset_pwd,
                        },
                        {
                            path: 'setdownrole',
                            name: 'setdownrole',
                            component: org_user_setdownrole,
                        },
                        {
                            path: 'listdownrole',
                            name: 'listdownrole',
                            component: org_user_listdownrole,
                        },
                        {
                            path: 'ewm',
                            name: 'ewm',
                            component: org_user_ewm,
                        }
                    ]
                },
                {
                    path: 'downs0',
                    name: 'downs0',
                    component: org_downs0,
                    children: [
                        {
                            path: 'add',
                            name: 'add',
                            component: org_downs0_add,
                        },
                        {
                            path: 'upd',
                            name: 'upd',
                            component: org_downs0_upd,
                        },
                        {
                            path: 'setup',
                            name: 'setup',
                            component: org_downs0_setup,
                        },
                        {
                            path: 'msg',
                            name: 'msg',
                            component: org_downs0_msg,
                        },
                        {
                            path: 'higset',
                            name: 'higset',
                            component: org_downs0_higset,
                        },
                        {
                            path: 'admin',
                            name: 'admin',
                            component: org_downs0_admin,
                        },
                        {
                            path: 'org_admin',
                            name: 'org_admin',
                            component: org_downs0_org_admin,
                        },
                        {
                            path: 'ewm',
                            name: 'ewm',
                            component: org_ewm_wxmp
                        }
                    ]
                },
                {
                    path: 'downs1',
                    name: 'downs1',
                    component: org_downs1,
                    children: [
                        {
                            path: 'upd',
                            name: 'upd',
                            component: org_downs1_upd,
                        },
                        {
                            path: 'setup',
                            name: 'setup',
                            component: org_downs1_setup,
                        },
                        {
                            path: 'msg',
                            name: 'msg',
                            component: org_downs1_msg,
                        }
                    ]
                },
                {
                    path: 'downs2',
                    name: 'downs2',
                    component: org_downs2,
                    children: [
                        {
                            path: 'upd',
                            name: 'upd',
                            component: org_downs2_upd,
                        },
                        {
                            path: 'setup',
                            name: 'setup',
                            component: org_downs2_setup,
                        },
                        {
                            path: 'msg',
                            name: 'msg',
                            component: org_downs2_msg,
                        }
                    ]
                },
                {
                    path: 'downroles1',
                    name: 'downroles1',
                    component: org_downroles1,
                    children: [
                        {
                            path: 'adddownroles1',
                            name: 'adddownroles1',
                            component: org_downroles1_add
                        },
                        {
                            path: 'downroles1func',
                            name: 'downroles1func',
                            component: org_downroles1_func
                        },
                        {
                            path: 'downroles1delete',
                            name: 'downroles1delete',
                            component: org_downroles1_delete
                        }
                    ]
                },
                {
                    path: 'downroles2',
                    name: 'downroles2',
                    component: org_downroles2,
                    children: [
                        {
                            path: 'adddownroles2',
                            name: 'adddownroles2',
                            component: org_downroles2_add
                        },
                        {
                            path: 'downroles2func',
                            name: 'downroles2func',
                            component: org_downroles2_func
                        },
                        {
                            path: 'downroles2delete',
                            name: 'downroles2delete',
                            component: org_downroles2_delete
                        }
                    ]
                }
            ]
        },
        // email
        {
            path: '/email',
            name: 'email',
            component: index,
            children: [
                {
                    path: 'record',
                    name: 'record',
                    component: email_record,
                },
                {
                    path: 'record_detail',
                    name: 'record_detail',
                    component: email_record_detail,
                },
                {
                    path: 'template',
                    name: 'template',
                    component: email_template,
                },
            ],
        },

        // others
        {
            path: '/others',
            name: 'others',
            component: index,
            children: [
                {
                    path: 'alumni',
                    name: 'alumni',
                    component: alumni,
                },
                {
                    path: 'parent',
                    name: 'parent',
                    component: parent,
                },
                {
                    path: 'student',
                    name: 'student',
                    component: student,
                },
            ],
        },

        // teacher
        {
            path: '/teacher',
            name: 'teacher',
            component: index,
            children: [
                {
                    path: 'record',
                    name: 'record',
                    component: teacher_record,
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: teacher_profile,
                },
                {
                    path: 'profile_detail',
                    name: 'profile_detail',
                    component: teacher_profile_detail,
                },
                {
                    path: 'record_detail',
                    name: 'record_detail',
                    component: teacher_record_detail,
                },
                {
                    path: 'trans_record',
                    name: 'trans_record',
                    component: teacher_record_trans,
                },
                {
                    path: 'expire',
                    name: 'expire',
                    component: teacher_expire,
                },
            ],
        },
        // faculty
        {
            path: '/faculty',
            name: 'faculty',
            component: index,
            children: [
                {
                    path: 'list',
                    name: 'list',
                    component: faculty_record,
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: faculty_profile,
                },
                {
                    path: 'profile_detail',
                    name: 'profile_detail',
                    component: faculty_profile_detail,
                },
                {
                    path: 'record_detail',
                    name: 'record_detail',
                    component: faculty_record_detail,
                },
                {
                    path: 'trans_record',
                    name: 'trans_record',
                    component: faculty_record_trans,
                },
                {
                    path: 'expir',
                    name: 'expir',
                    component: faculty_expire,
                },
            ],
        },

        // school
        {
            path: '/school',
            name: 'school',
            component: index,
            children: [
                {
                    path: 'record',
                    name: 'record',
                    component: school_record,
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: school_profile,
                },
                {
                    path: 'profile_detail',
                    name: 'profile_detail',
                    component: school_profile_detail,
                },
                {
                    path: 'record_detail',
                    name: 'record_detail',
                    component: school_record_detail,
                },
                {
                    path: 'recruit_detail',
                    name: 'recruit_detail',
                    component: school_record_recruit_detail,
                },
                {
                    path: 'job',
                    name: 'job',
                    component: school_job,
                },
                {
                    path: 'expire',
                    name: 'expire',
                    component: school_expire,
                },
                {
                    path: 'white',
                    name: 'white',
                    component: school_white,
                },
            ],
        },
        // school
        {
            path: '/cent',
            name: 'cent',
            component: index,
            children: [
                {
                    path: 'list',
                    name: 'list',
                    component: cent_list,
                },
            ],
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '*',
            redirect: '/index/welcome'
        },
    ],
})



// WEBPACK FOOTER //
// ./src/router/index.js